class UniqueIdGenerator {
  constructor() {
    this.cache = new Map();
    this.currentNumber = 0;
  }

  getId(str) {
    const cachedNumber = this.cache.get(str);

    if (typeof cachedNumber !== 'undefined') return cachedNumber;

    const { currentNumber } = this;
    this.cache.set(str, currentNumber);
    this.currentNumber += 1;
    return currentNumber;
  }
}

export { UniqueIdGenerator };
